import { createSlice } from '@reduxjs/toolkit';
import { authApiService } from '../../Apis/Auth';
import { emptySession, normalizeSession } from '../../../utils/authSession';
export const AuthSlice = createSlice({
  name: 'authSlice',
  initialState: emptySession(),
  reducers: {
    logout: () => emptySession(),
    setAuthData: (state, action) => normalizeSession(action.payload),
    updateUser: (state, action) => {
      if (state.user) for (const key of ['first_name', 'last_name', 'phone']) {
        if (action.payload[key] !== undefined) state.user[key] = action.payload[key];
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(authApiService.endpoints.login.matchFulfilled, (state, action) =>
      action.payload?.success ? normalizeSession(action.payload) : emptySession());
  },
});
export const { logout, updateUser, setAuthData } = AuthSlice.actions;
export default AuthSlice.reducer;
